import { useRef, useState } from "react";
import { BookOpen } from "lucide-react";
import { MobileDialog } from "../mobile/MobileDialog";

// Reading the written pack is optional. Do not mount its data-fetching cards
// or grow the lesson screen until the instructor deliberately opens it.
export default function OptionalLessonWindow({ children, initiallyOpen = false }) {
  const [open, setOpen] = useState(initiallyOpen);
  const trigger = useRef(null);
  const close = () => {
    setOpen(false);
    requestAnimationFrame(() => trigger.current?.focus({ preventScroll: true }));
  };
  return (
    <>
      <button
        type="button"
        ref={trigger}
        data-testid="open-briefing-pack"
        aria-haspopup="dialog"
        aria-expanded={open}
        onClick={() => setOpen(true)}
        className="inline-flex min-h-11 items-center justify-center gap-2 rounded-xl border border-white/30 bg-slate-950/65 px-4 py-2 text-sm font-semibold text-white backdrop-blur-sm"
      >
        <BookOpen className="h-4 w-4" />
        Briefing pack
      </button>
      {open && (
        <MobileDialog
          open
          onClose={close}
          title="Briefing pack"
          description="Written information to look through when you need it."
          testid="briefing-pack-window"
          widthClass="sm:max-w-2xl"
          panelClassName="bg-slate-900"
          footer={(
            <button
              type="button"
              onClick={close}
              className="min-h-11 rounded-xl bg-slate-700 px-5 py-2 font-semibold text-white"
            >
              Back to lesson
            </button>
          )}
        >
          <div className="space-y-5 text-white">{children}</div>
        </MobileDialog>
      )}
    </>
  );
}
